import { LABELSTATUS } from './constants';

export const getPercentage = (count, totalCount) => {
  if (totalCount === 0) return '0%';

  return `(${Math.floor((count * 100) / totalCount)}%)`;
};

export const calculatePercentage = (count, totalCount) =>
  totalCount === 0 ? 0 : Math.floor((count * 100) / totalCount);

export const getIconKind = (labelStatus) => {
  switch (labelStatus) {
    case LABELSTATUS.MANAGER_NOT_CONFIRMED:
      return 'NotConfirmedUser1';
    case LABELSTATUS.REVOKED:
      return 'Revoked';
    case LABELSTATUS.CONSULT:
      return 'Consult';
    case LABELSTATUS.ROLE:
      return 'Role';
    case LABELSTATUS.ACCOUNT:
      return 'Account';
    case LABELSTATUS.USER:
      return 'User';
    case LABELSTATUS.ENTITLEMENT:
    case LABELSTATUS.PARENT_ENTITLEMENT:
    case LABELSTATUS.CHILD_ENTITLEMENT:
      return 'Entitlement';
    case LABELSTATUS.APPROVED:
      return 'Check';
    case LABELSTATUS.TERMINATED:
      return 'Terminate';
    case LABELSTATUS.NO_ACTION_REQUIRED:
    case LABELSTATUS.REJECTED:
    case LABELSTATUS.DECOMMISSIONED:
      return 'Reject';
    case LABELSTATUS.END_DATE_CHANGED:
      return 'ExtendEndDate';
    case LABELSTATUS.CONDITIONALLY_CERTIFIED:
    case LABELSTATUS.PENDING:
    case LABELSTATUS.REASSIGN:
    case LABELSTATUS.DOES_NOT_BELONG_TO_ME:
      return 'Reassign';
    case LABELSTATUS.MANAGER_CONFIRMED:
    default:
      return 'ConfirmManager';
  }
};

export const isEmptyObject = (obj) => Object.keys(obj).length === 0;

// Sort order in progress page
export const roleOrder = { User: 0, Account: 1, Role: 2, Entitlement: 3 };
export const eoRoleOrder = { ParentEnt: 0, Account: 1, ChildEntitlement: 2 };

export const decisionOrder = {
  'Manager Confirmed': 0,
  ManagerConfirmed: 0,
  'Manager Confirmed With End Date Changed': 1,
  ManagerConfirmedWithEndDateChanged: 1,
  'Not Confirmed By Manager': 2,
  Terminated: 3,
  Approved: 4,
  Rejected: 5,
  'End Date Changed': 6,
  EndDateChanged: 6,
  'Conditionally Certified': 7,
  ConditionallyCertified: 7,
  Reassigned: 8,
  'No Action Required': 9,
  NoActionRequired: 9,
};

export const customSortByDecision = (a, b) => {
  const decisionA = a[0];
  const decisionB = b[0];

  return decisionOrder[decisionA] - decisionOrder[decisionB];
};

export const customSortByType = (a, b) => {
  const roleA = a[0];
  const roleB = b[0];

  return roleOrder[roleA] - roleOrder[roleB];
};

export const customEoSortByType = (a, b) => {
  const roleA = a[0];
  const roleB = b[0];

  return eoRoleOrder[roleA] - eoRoleOrder[roleB];
};

export default {
  getPercentage,
  getIconKind,
  isEmptyObject,
  customSortByType,
  customEoSortByType,
};
